<template>
<!--  司机派单明细报表 -->
  <div class="common-page staff-management">
    <div class="search-form-box">
      <el-row :gutter="30">
        <el-form inline>
          <el-col :span="5">
            <el-form-item label="日期范围:">
              <custom-date-range
                :start-date="searchForm.startTime"
                :end-date="searchForm.endTime"
                @update:startDate="(val) => (searchForm.startTime = val)"
                @update:endDate="(val) => (searchForm.endTime = val)"></custom-date-range>
            </el-form-item>
          </el-col>
          <el-col :span="5" v-if="companyType === '1'">
            <el-form-item label="分公司:">
              <el-select style="width: 100%" v-model="searchForm.belongCompanyId" placeholder="请选择">
                <el-option
                  v-for="item in belongCompanyData"
                  :key="item.companyId"
                  :label="item.companyName"
                  :value="item.companyId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="服务商:">
              <el-select style="width: 100%" clearable v-model="searchForm.companyId" placeholder="请选择">
                <el-option
                  v-for="item in supplierData"
                  :key="item.companyId"
                  :label="item.companyName"
                  :value="item.companyId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="订单来源:">
              <el-select style="width: 100%" clearable v-model="searchForm.orderSource" placeholder="请选择">
                <el-option
                  v-for="item in orderSourceData"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="司机:">
              <el-input style="width: 100%" clearable v-model="searchForm.driver" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="">
              <el-button type="primary" round icon="el-icon-search" @click="handleCheck()"></el-button>
              <el-button type="default" round icon="el-icon-refresh" @click="handleReset(['belongCompanyId'])"></el-button>
              <el-button type="primary" :loading="downloadLoading" @click="handleDownload(`司机派单明细报表${searchForm.startTime}-${searchForm.endTime}.xlsx`)">导出</el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </div>
    <div class="custom-table-box">
      <custom-table
        :data="tableData"
        :column="tableColumn"
        :total="tableOptions.total"
        :loading="tableOptions.loading"
        :page="tableOptions.currentPage"
        :size="tableOptions.pageSize"
        :selection="false"
        :showIndex="true"
        @pagination="handleSizeChange"
      >
        <!--        订单来源-->
        <template v-slot:orderSource="{ row }">
          <div v-if="row.orderSource === 1">平台订单</div>
          <div v-if="row.orderSource === 2">第三方平台订单</div>
        </template>
        <template v-slot:pointList="{ row }">
          <div>{{row.pointList[row.pointList.length-1].linkUsername}} {{row.pointList[row.pointList.length-1].linkPhone}}</div>
          <div>{{row.pointList[row.pointList.length-1].provinceName}}{{row.pointList[row.pointList.length-1].cityName}}{{row.pointList[row.pointList.length-1].districtName}}</div>
          <div>{{ row.pointList[row.pointList.length-1].address }}</div>
        </template>
        <template v-slot:weight="{ row }">
          <div>{{ row.weight || "-" }}{{row.wightUnit === 1?'吨':'公斤'}}</div>
        </template>
        <template v-slot:volume="{ row }">
          <div>{{ row.volume || "-" }}m³</div>
        </template>


        <!--        车辆箱型-->
        <template v-slot:vehicleMode="{ row }">
          <div>{{ row.vehicleMode }}</div>
          <div>{{ row.vehicleLength }}</div>
          <div>{{ row.vehicleUseType }}</div>
        </template>
<!--        <template v-slot:price="{ row }">-->
<!--          <div>-->
<!--            订单金额：<span class="color1966ff">{{-->
<!--              row.fee || "-"-->
<!--            }}</span>-->
<!--          </div>-->
<!--          <div>-->
<!--            技术服务费：<span class="color1966ff">{{-->
<!--              row.technicalFee || "-"-->
<!--            }}</span>-->
<!--          </div>-->
<!--          <div>-->
<!--            不可退定金：<span class="color1966ff">{{-->
<!--              row.deposit || "-"-->
<!--            }}</span>-->

<!--          </div>-->

<!--        </template>-->
        <template v-slot:ownerName="{ row }">
          <div>{{row.ownerName}} {{row.ownerPhone}}</div>
          <div>{{row.pointList[0].provinceName}}{{row.pointList[0].cityName}}{{row.pointList[0].districtName}}</div>
          <div>{{row.pointList[0].address}}</div>
        </template>
        <template v-slot:cancelType="{ row }">
          <div v-if="row.cancelType === 1">超时</div>
          <div v-if="row.cancelType === 2">司机取消</div>
          <div v-if="row.cancelType === 3">货主取消</div>
          <div v-if="row.cancelType === 4">后台取消</div>
        </template>
      </custom-table>
    </div>

    <!--    添加或编辑-->
    <addOrEdit ref="addOrEdit"></addOrEdit>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import addOrEdit from "./addOrEdit.vue";
import {  downloadExcel, getPage } from "./api";
import tableMixin from "@/mixin/tableMixin";
import CustomDateRange from "@/components/CustomDateRange.vue";
import { getSelectSupplier } from "@/views/SystemManagement/ServiceManagement/api";
export default {
  name: "DriverPerformanceReport",
  mixins: [tableMixin],
  components: {
    CustomDateRange,
    OperateBox,
    CustomTable,
    addOrEdit,
  },
  data() {
    return {
      getTableMethod: getPage,
      downloadFileMethod: downloadExcel,
      orderSourceData: [
        {
          value: 1,
          label: "平台订单"
        },
        {
          value: 2,
          label: "第三方平台订单"
        }
      ],
      supplierData: [],
      haveBelongCompany: true,
      searchForm: {
        startTime: "",
        belongCompanyId: "",
        endTime: "",
        driver: "",
        companyId: "",
        orderSource: "",
      },
      tableColumn: [
        {
          label: "日期",
          prop: "createTime",
          align: "left",
          width: "120px",
          show: true,
        },
        {
          label: "订单号",
          prop: "orderNo",
          align: "left",
          width: "220px",
          show: true,
        },
        {
          label: "订单来源",
          prop: "orderSource",
          align: "center",
          width: "120px",
          scopeStatus: true,
          show: true,
        },
        {
          label: "所属服务商",
          prop: "driverCompanyName",
          align: "center",
          width: "150px",
          show: true,
        },
        {
          label: "司机姓名",
          prop: "driverName",
          align: "left",
          width: "120px",
          show: true,
        },

        {
          label: "车号",
          prop: "carNumber",
          align: "left",
          width: "120px",
          show: true,
        },
        {
          label: "线路",
          prop: "pointList",
          align: "left",
          width: "350px",
          scopeStatus: true,
          show: true,
        },
        {
          label: "货物重量",
          prop: "weight",
          align: "left",
          scopeStatus: true,
          show: true,
        },
        {
          label: "货物体积",
          prop: "volume",
          align: "left",
          scopeStatus: true,
          show: true,
        },
        {
          label: "装货方式",
          prop: "packingWays",
          align: "left",
          show: true,
        },
        {
          label: "订单金额",
          prop: "fee",
          width: "120px",
          align: "left",
          show: true,
        },
        {
          label: "技术服务费",
          prop: "technicalFee",
          width: "120px",
          align: "left",
          show: true,
        },
        {
          label: "不可退定金",
          prop: "deposit",
          width: "120px",
          align: "left",
          show: true,
        },
        {
          label: "装货信息",
          prop: "ownerName",
          align: "left",
          width: "200px",
          scopeStatus: true,
          show: true,
        },
        {
          label: "卸货信息",
          prop: "pointList",
          align: "left",
          width: "200px",
          scopeStatus: true,
          show: true,
        },
        {
          label: "派单调度",
          prop: "dispatcherName",
          align: "left",
          show: true,
        },
        {
          label: "发车时间",
          prop: "startLoadTime",
          align: "left",
          width: "170px",
          show: true,
        },
        {
          label: "派单时间",
          prop: "dispatchTime",
          align: "left",
          width: "170px",
          show: true,
        },
        {
          label: "接单时间",
          prop: "driverConfirmTime",
          align: "left",
          width: "170px",
          show: true,
        },
        {
          label: "取消时间",
          prop: "cancelTime",
          align: "left",
          width: "170px",
          show: true,
        },
        {
          label: "取消原因",
          prop: "cancelType",
          align: "left",
          scopeStatus: true,
          show: true,
        },

      ],
      isImmediatelyGetData: true,
    };
  },
  watch: {
    "searchForm.belongCompanyId":function(val) {
      this.searchForm.companyId = ""
      this.getSelectSupplierData(val)
    }
  },
  created() {},
  methods: {
    getSelectSupplierData(val) {
      getSelectSupplier({belongCompanyId: val, keyword: ''}).then(response => {
        if (response.code === 200) {
          this.supplierData = response.data
        }
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.staff-management {
  .custom-table-box{
    padding-top: 0;
  }
  .search-form-title {
    font-weight: 400;
    font-size: 0.16rem;
    color: #111827;
    line-height: 0.24rem;
    padding-bottom: 0.08rem;
  }
}
</style>
